import { nextTick } from 'vue';
import ObserverManager from '@app/global/ViewportObserver';
export default {
    beforeMount(el, binding) {
        if (!binding.value || typeof binding.value === 'string') {
            el.classList.add(binding.value || 'observe' + '-before-enter');
            el.addEventListener('transitionend', () => {
                el.classList.remove(binding.value || 'observe' + '-before-enter');
                el.classList.remove('observe-enter');
                el.classList.remove('enter');
            });
        }
    },
    mounted(el, binding) {
        nextTick(() => {
            ObserverManager.add(el, () => {
                if (typeof binding.value === 'function') {
                    binding.value();
                }
                el.classList.add('enter');
            });
        });
    },
};
